module.exports = __webpack_public_path__ + "static/media/home-lg-alt.eefb0607.svg";